import React, { useContext } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { colors, ThemeContext, fontSize, breakpoints } from "style";
import { TextLoader } from "components/Loader";

/**
 * Heading 2
 */
const StyledH2 = styled.h2`
  font-size: ${fontSize.large};
  font-weight: 600;
  margin: 0;
  color: ${colors.purpleRainDark2};
  ${(props) => props.themeStyle}

  ${({ isPublic }) =>
    isPublic &&
    `
    font-size: ${fontSize.xxlarge};
    margin-bottom:3rem;
  `}

  @media (max-width: ${breakpoints.tablet}) {
    font-size: ${fontSize.normal};
  }
`;

const H2 = ({ loading, ...props }) => {
  const theme = useContext(ThemeContext);

  if (loading) {
    return (
      <StyledH2 themeStyle={theme.h1} loading={loading} {...props}>
        <TextLoader css={styles.loader} />
      </StyledH2>
    )
  };

  return <StyledH2 themeStyle={theme.h1} {...props} />;
};

const styles = {
  loader: css`
    width: 50rem;
    mac-width: 100%;
    height: 2.5rem;
    background: ${colors.grayAnatomyLight4};
  `,
};


export default H2;
